import { useMutation } from '@tanstack/react-query'
import { inviteAgendaMemberService } from '@/services/agendas'

export const useInviteAgendaMember = (agendaId: string) =>
  useMutation({
    mutationFn: (email: string) => inviteAgendaMemberService(agendaId, email),
  })
